import React, { memo } from 'react'

const TableContainer = ({ children, outerRef, innerRef }) => {
    return (
        <div className={'table-outer'} ref={outerRef}>
            <div className={'table-inner'} ref={innerRef}>
                {children}
            </div>
        </div>
    )
}

export default memo(TableContainer)
